module.exports = __webpack_public_path__ + "img/bj.554f06a7.jpg";